import styled from "@emotion/styled"

const FooterFirstColumn = styled.div``

export default FooterFirstColumn
